/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from "react";
import * as THREE from "three";
import { useGLTF, useAnimations, useTexture } from "@react-three/drei";
import model from "./Casa-Jhun-Modified.glb";
import cadeira from "./materials/Cadeiras_Diffuse.jpg";
import emmit from "./materials/Luminarias_Emit.jpg";
import boxWoodAlpha from "./T_Boxwood_Alpha.jpg";
import boxWoodDiffuse from "./MI_Boxwood_wfypfa3ha_Billboard_1K (Base Color) image.png";
import boxWoodNormal from "./T_Boxwood_Normal.jpg";
import sphereBackground from "./materials/HDR_029_Sky_Cloudy_Bg.jpg";
import tDragonDiffuse from "./T_Dragon_Diffuse.jpg";

export default function Model(props) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF(model);
  const { actions } = useAnimations(animations, group);
  const cadeiraTexture = useTexture(cadeira);
  const emmitTexture = useTexture(emmit);
  const boxWoodAlphaTexture = useTexture(boxWoodAlpha);
  const boxWoodDiffuseTexture = useTexture(boxWoodDiffuse);
  const boxWoodNormalTexture = useTexture(boxWoodNormal);
  const tDragonDiffuseTexture = useTexture(tDragonDiffuse);

  const backgroundSphere = useTexture(sphereBackground);

  useEffect(() => {
    // console.log(materials);
    // materials.MI_Boxwood_wfypfa3ha_Billboard_1K.transparent = true;
    // materials.MI_Boxwood_wfypfa3ha_Billboard_1K.alphaMap = boxWoodAlphaTexture;
    // materials.MI_Boxwood_wfypfa3ha_Billboard_1K.envMapIntensity = 1;
    // materials.MI_Boxwood_wfypfa3ha_Billboard_1K.emissive = new THREE.Color(
    //   "#ffffff"
    // );
    // materials.MI_Boxwood_wfypfa3ha_Billboard_1K.emissiveIntensity = 0.0;
    // materials.MI_Boxwood_wfypfa3ha_Billboard_1K.roughness = 0;
    // materials.MI_Boxwood_wfypfa3ha_Billboard_1K.metalness = -0.1;
    // materials.MI_Boxwood_wfypfa3ha_Billboard_1K.blending = THREE.NormalBlending;
  }, []);
  Object.entries(materials).forEach(([key, value]) => {
    value.envMapIntensity = props.envMapIntensity;
  });
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh visible position={[0, 0, 0]} rotation={[0, Math.PI, 0]}>
        <sphereGeometry attach="geometry" args={[60, 40, 40]} />
        <meshBasicMaterial
          attach="material"
          color="white"
          roughness={0.1}
          metalness={1}
          map={backgroundSphere}
          side={THREE.BackSide}
        />
      </mesh>
      <group>
        <mesh
          name="Paredes"
          castShadow
          receiveShadow
          geometry={nodes.Paredes.geometry}
          material={materials.Paredes}
        />
        <mesh
          name="Forro"
          castShadow
          receiveShadow
          geometry={nodes.Forro.geometry}
          material={materials.Forro}
          position={[4.68, 2.6, -0.9]}
        />
        <mesh
          name="Piso"
          castShadow
          receiveShadow
          geometry={nodes.Piso.geometry}
          material={materials.Piso}
          material-envMapIntensity={1}
          position={[0.28, -0.09, -0.28]}
        />
        <mesh
          name="Esquadria"
          castShadow
          receiveShadow
          geometry={nodes.Esquadria.geometry}
          material={materials.Esquadria}
          position={[2.52, 1.3, -0.62]}
        />
        <mesh
          name="Banco"
          castShadow
          receiveShadow
          geometry={nodes.Banco.geometry}
          material={materials.Banco}
          position={[2.79, 0.33, -7.74]}
        />
        <mesh
          name="Espreguicadeira_A"
          castShadow
          receiveShadow
          geometry={nodes.Espreguicadeira_A.geometry}
          material={materials.Espreguicadeira_A}
          position={[-2.45, 0.04, -9.22]}
          rotation={[0, 0.22, 0]}
        />
        <mesh
          name="Ripado"
          castShadow
          receiveShadow
          geometry={nodes.Ripado.geometry}
          material={materials.Ripado}
          position={[7.08, 1.79, 5.49]}
        />
        <mesh
          name="LuminariasCilindricas"
          castShadow
          receiveShadow
          geometry={nodes.LuminariasCilindricas.geometry}
          material={materials.LuminariasCilindricas}
          position={[2.08, 2.597, 5.9]}
          renderOrder={100}
        />
        <mesh
          name="Espreguicadeira_B"
          castShadow
          receiveShadow
          geometry={nodes.Espreguicadeira_B.geometry}
          material={materials.Espreguicadeira_B}
          position={[-0.57, 0.04, -9.18]}
          rotation={[0, -0.27, 0]}
        />
        <mesh
          name="Banqueta_A001"
          castShadow
          receiveShadow
          geometry={nodes.Banqueta_A001.geometry}
          material={materials.Banqueta_A}
          position={[9.73, 0, 5.14]}
          rotation={[-Math.PI, 0.13, -Math.PI]}
        />
        <mesh
          name="Luminarias"
          castShadow
          receiveShadow
          geometry={nodes.Luminarias.geometry}
          material={materials.LuminariasPendentes}
          position={[9.88, 2.5, 5.79]}
        />
        <mesh
          name="Balcao001"
          castShadow
          receiveShadow
          geometry={nodes.Balcao001.geometry}
          material={materials.Balcao}
          position={[10.53, 0, 5.78]}
          rotation={[Math.PI, 0, Math.PI]}
        />
        <mesh
          name="Recipientes"
          castShadow
          receiveShadow
          geometry={nodes.Recipientes.geometry}
          material={materials.Recipientes}
          position={[7.8, 0.9, 5.84]}
        />
        <mesh
          name="Banqueta_B001"
          castShadow
          receiveShadow
          geometry={nodes.Banqueta_B001.geometry}
          material={materials.Banqueta_B}
          position={[9.05, 0, 5.18]}
          rotation={[Math.PI, -0.31, Math.PI]}
        />
        <mesh
          name="ArmarioCozinha"
          castShadow
          receiveShadow
          geometry={nodes.ArmarioCozinha.geometry}
          material={materials.ArmarioCozinha}
          position={[9.15, 0, 7.9]}
        />
        <mesh
          name="MesinhaApoio"
          castShadow
          receiveShadow
          geometry={nodes.MesinhaApoio.geometry}
          material={materials.MesinhaApoio}
          position={[-3.43, 0.38, -9.87]}
        />
        <mesh
          name="MesaJantar"
          castShadow
          receiveShadow
          geometry={nodes.MesaJantar.geometry}
          material={materials.MesaJantar}
          position={[6.64, 0, 0.22]}
        />
        <mesh
          name="Cadeiras"
          castShadow
          receiveShadow
          geometry={nodes.Cadeiras.geometry}
          material={materials.Cadeiras}
          material-map={cadeiraTexture}
          material-map-flipY={false}
          position={[6.11, 0.34, 0.01]}
        />
        <mesh
          name="Poltrona_A"
          castShadow
          receiveShadow
          geometry={nodes.Poltrona_A.geometry}
          material={materials.Poltrona_A}
          position={[7.47, 0.2, -5.5]}
          rotation={[0, -Math.PI / 2, 0]}
        />
        <mesh
          name="Sofa"
          castShadow
          receiveShadow
          geometry={nodes.Sofa.geometry}
          material={materials.Sofa}
          position={[5.96, 0.2, -6.51]}
          rotation={[0, -Math.PI / 2, 0]}
        />
        <mesh
          name="Puff"
          castShadow
          receiveShadow
          geometry={nodes.Puff.geometry}
          material={materials.Puff}
          position={[6.02, 0.19, -4]}
          rotation={[0, -Math.PI / 2, 0]}
        />
        <mesh
          name="MesaCentro"
          castShadow
          receiveShadow
          geometry={nodes.MesaCentro.geometry}
          material={materials.MesaCentro}
          position={[6.01, 0.23, -5.24]}
          rotation={[0, -Math.PI / 2, 0]}
        />
        <mesh
          name="Poltrona_B"
          castShadow
          receiveShadow
          geometry={nodes.Poltrona_B.geometry}
          material={materials.Poltrona_B}
          position={[7.47, 0.2, -4.62]}
          rotation={[0, -Math.PI / 2, 0]}
        />
        <mesh
          name="VidroCerca001"
          castShadow
          receiveShadow
          geometry={nodes.VidroCerca001.geometry}
          material={materials.Vidro}
          // material-side={THREE.FrontSide}
          material-depthTest={true}
          material-depthWrite={false}
          position={[-4.45, 0.66, -0.06]}
        />
        <mesh
          name="AguaPiscina"
          castShadow
          receiveShadow
          geometry={nodes.AguaPiscina.geometry}
          material={materials.Agua}
          material-envMapIntensity={0.5}
          material-roughness={0}
          material-depthWrite={false}
          position={[-0.88, -0.08, -2.01]}
        />
        <mesh
          name="Arvores"
          castShadow
          receiveShadow
          geometry={nodes.Arvores.geometry}
          position={[-7.74, 1.61, -0.98]}
          // renderOrder={0}
        >
          <meshStandardMaterial
            map={tDragonDiffuseTexture}
            map-flipY={false}
            // alphaMap={boxWoodAlphaTexture}
            // alphaMap-flipY={false}
            // side={THREE.DoubleSide}
            transparent
            depthWrite={true}
            depthTest={true}
            roughness={1}
            metalness={0.5}
            color={new THREE.Color("#bb8800")}
            emissive={new THREE.Color("#000000")}
          />
        </mesh>
        <mesh
          name="Arbustos"
          castShadow
          receiveShadow
          geometry={nodes.Arbustos.geometry}
          position={[-3.86, 0.51, -0.02]}
          renderOrder={1}
        >
          <meshBasicMaterial
            map={boxWoodDiffuseTexture}
            map-flipY={false}
            // alphaMap={boxWoodAlphaTexture}
            // alphaMap-flipY={false}
            side={THREE.DoubleSide}
            transparent
            // alphaTest={0.4}
            depthWrite={false}
            depthTest={true}
            roughness={0.5}
            metalness={0}
          />
        </mesh>
        <mesh
          name="Vidraca"
          castShadow
          receiveShadow
          geometry={nodes.Vidraca.geometry}
          material={materials.Vidro}
          position={[3.13, 1.3, 1.51]}
        />
        <mesh
          name="Gramado001"
          receiveShadow
          geometry={nodes.Gramado001.geometry}
          material={materials.Grama}
          material-envMapIntensity={0}
          material-color={new THREE.Color("#f0bb44")}
          material-roughness={0.8}
          material-metalness={1}
          material-emissive={new THREE.Color("#445500")}
          position={[-2.77, -0.24, 0.04]}
        />
        <mesh
          name="Cerca001"
          castShadow
          receiveShadow
          geometry={nodes.Cerca001.geometry}
          material={materials.PinturaPreta}
          position={[-6.01, 0.66, -0.06]}
        />
        <mesh
          name="Escada"
          castShadow
          receiveShadow
          geometry={nodes.Escada.geometry}
          material={materials.Escada}
          position={[0.99, -0.11, 0.04]}
        />
      </group>
    </group>
  );
}

useGLTF.preload(model);
